const Hero = () => {
  return (
    <section
      id='home'
      className='relative min-h-screen flex items-center justify-center overflow-hidden bg-linear-to-br from-primary-50 via-white to-primary-100'
    >
      {/* Background Pattern */}
      <div className='absolute inset-0 overflow-hidden'>
        <div className='absolute -top-40 -right-40 w-80 h-80 bg-primary-200 rounded-full opacity-20 blur-3xl' />
        <div className='absolute -bottom-40 -left-40 w-80 h-80 bg-primary-300 rounded-full opacity-20 blur-3xl' />
      </div>

      <div className='relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center'>
        {/* Badge */}
        <div className='inline-flex items-center space-x-2 bg-white rounded-full px-4 py-2 shadow-md mb-8'>
          <span className='flex h-2 w-2 relative'>
            <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75' />
            <span className='relative inline-flex rounded-full h-2 w-2 bg-primary-500' />
          </span>
          <span className='text-sm font-medium text-gray-700'>Free Aplikasi Selamanya!</span>
        </div>

        {/* Headline */}
        <h1 className='text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6'>
          Kartu PVC/Digital Modern
          <br />
          <span className='text-primary-600'>untuk Bisnis Anda</span>
        </h1>

        <p className='text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-10'>
          Solusi kartu pintar dengan aplikasi gratis selamanya. Kartu Pelajar, Kartu Member, dan
          Kartu Nama digital yang membantu bisnis Anda lebih efisien dan profesional.
        </p>

        {/* CTA Buttons */}
        <div className='flex flex-col sm:flex-row items-center justify-center gap-4'>
          <a
            href='https://wa.me/6285235662062?text=Halo,%20saya%20tertarik%20dengan%20ScanKartu'
            className='btn-primary inline-flex items-center space-x-2'
          >
            <svg className='w-5 h-5' fill='currentColor' viewBox='0 0 24 24'>
              <path d='M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z' />
            </svg>
            <span>Chat WhatsApp</span>
          </a>
          <a href='#products' className='btn-secondary inline-flex items-center space-x-2'>
            <span>Lihat Produk</span>
            <svg className='w-5 h-5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M19 9l-7 7-7-7'
              />
            </svg>
          </a>
        </div>

        {/* Stats */}
        <div className='grid grid-cols-3 gap-8 mt-16 pt-16 border-t border-gray-200'>
          <div>
            <div className='text-3xl md:text-4xl font-bold text-primary-600'>100%</div>
            <div className='text-gray-600 mt-1'>Free Aplikasi</div>
          </div>
          <div>
            <div className='text-3xl md:text-4xl font-bold text-primary-600'>24/7</div>
            <div className='text-gray-600 mt-1'>Support</div>
          </div>
          <div>
            <div className='text-3xl md:text-4xl font-bold text-primary-600'>∞</div>
            <div className='text-gray-600 mt-1'>Update Gratis</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
